import React, { Component } from 'react';

import { BoxContentTestimunials }  from '../../helpers/section';
import { isMobile } from 'react-device-detect';

const testimunials = [
    {col: 'col-12 col-md-4 col-lg-4', name:'John Doe', office: 'Manager', description: 'lLorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet maiores necessitatibus quasi minus sequi incidunt obcaecati possimus totam? Aperiam recusandae rem dignissimos cupiditate porro soluta voluptatibus deleniti sit nulla vel?orem'},
    {col: 'col-12 col-md-4 col-lg-4', name:'John Doe', office: 'Manager', description: 'lLorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet maiores necessitatibus quasi minus sequi incidunt obcaecati possimus totam? Aperiam recusandae rem dignissimos cupiditate porro soluta voluptatibus deleniti sit nulla vel?orem'},
    {col: 'col-12 col-md-4 col-lg-4', name:'John Doe', office: 'Manager', description: 'lLorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet maiores necessitatibus quasi minus sequi incidunt obcaecati possimus totam? Aperiam recusandae rem dignissimos cupiditate porro soluta voluptatibus deleniti sit nulla vel?orem'},
];

class Testimunials extends Component {
    render() {
        return (
            <section className={isMobile ? 'home-testimonials-mobile' : 'home-testimonials'}>
                <div className="container">
                    <div className="row">
                        {testimunials.map((item,key) => { return BoxContentTestimunials(item,key) } )}
                    </div>                 
                </div>
            </section>
        )
    }
}

export default Testimunials;
